import {Box, Typography} from '@viptech/react-components'
import noFaceDetected from 'src/images/noneFaceDetected.png'

export default function NoneFaceDetected() {
  return (
    <Box display='flex' flex={1} overflow='hidden' backgroundColor='white' justifyContent='center' align='center' direction='column' rowGap='50px'>
      <img src={noFaceDetected} width={500} alt='Nenhuma face detectada' />
      <Box display='flex' justifyContent='center' align='center' direction='column' rowGap='20px'>
        <Typography variant='h3' color='#344054' size='40px'>
          Nenhuma face detectada
        </Typography>
        <Box display='flex' justifyContent='center' align='center' direction='column'>
          <Typography variant='label' color='#667085' size='16px'>
            Nenhuma face detectada no momento.
          </Typography>
          <Typography variant='label' color='#667085' size='16px'>
            Mantenha a câmera posicionada e aguarde novas detecções.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
